const defaultState = {
  keywords: null,
  selectedKeywordId: null,
}

export default defaultState
